import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/home-page";
import { NotFoundPage } from "./pages/not-found-page";
import { AddCarPage } from "./pages/add-car-page";
import { AddServicePage } from "./pages/add-service-page";
import { HelmetProvider } from "react-helmet-async";
import { EditCarPage } from "./pages/edit-car-page";
import AllServicesPage from "./pages/all-service-page";
import ServiceStepTwo from "./conponents/operate/add-services/service-step2";
import ServiceStepThree from "./conponents/operate/add-services/service-step3";
import OperReg from "./conponents/operate/oper-reg/oper-reg";
import OperdonInfinitPaging from "./conponents/operdone/all-operdon/operdon-infinit-pagin";
import EditOperdon from "./conponents/operdone/edit-operdon";
import { toast, ToastContainer } from "react-toastify";
import OperEdit from "./conponents/operate/oper-edit/oper-edit";
import Layout from "./layouts/lauout-2/layout";
import Register from "./modules/user/register/register";
import Login from "./modules/user/login";
import ChangePassword from "./modules/user/change-pass/change-pass";
import {ProtectedRoute} from "./services/protected-route";
import ForgotPassword from "./modules/user/forgot-password/forgot-pass";
import ForgotChange from "./modules/user/forgot-password/forgot-change";
import ForgotOTP from "./modules/user/forgot-password/forgot-otp";
import EditProfileForm from "./modules/user/account";
import ProtectedPageAxios from "./modules/user/ProtectedPage";
import UpdateNotification from './conponents/pages/UpdateNotification';
import ContactUs from "./pages/contact-us";
import useOnlineStatus from "./services/onlineStatus";
import Subscription from "./modules/user/subscription";
import PrivacyPolicy from "./conponents/pages/PrivacyPolicy";
import OfflinePage from "./pages/offlinePage";

function App() {
  const isOnline = useOnlineStatus();

  const handleRetry = () => {
    if (navigator.onLine) {
      window.location.reload(); // یا هر منطق دیگری که می‌خواهید
    } else {
      // می‌توانید Toast یا نوتیفیکیشن نمایش دهید
      toast.warning('هنوز آفلاین هستید', { autoClose: 1500 });
      console.log('هنوز آفلاین هستید');
    }
  };

  if (!isOnline) {
    return <OfflinePage onRetry={handleRetry} />;
  }

  return (
    <>
        {/* {!isOnline && (
          <div className="offline-banner">
            ❌ اتصال اینترنت قطع شده است
          </div>
        )} */}
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            // transition={Bounce}
        />

        <HelmetProvider>
          <BrowserRouter>
            {/* <MainLayout> */}
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/forgot" element={<ForgotPassword />} />
                <Route path="/forgot-otp/:mobile" element={<ForgotOTP />} />
                <Route path="/forgot-change/:mobile" element={<ForgotChange />} />

                <Route path="/" element={<ProtectedPageAxios><Layout /></ProtectedPageAxios>} >
                {/* <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>} > */}
                {/* <Route path="/" element={<Layout />}> */}
                  {/* <Route path="/" element={<HomePage />} /> در لی اوت قدیم */} 

                  <Route index element={<HomePage />} />
                  <Route path="/add-car" element={<AddCarPage />} />
                  <Route path="/edit-car/:id" element={<EditCarPage />} />
                  <Route path="/all-services" element={<AllServicesPage />} />
                  <Route path="/add-service" element={<AddServicePage />} />
                  <Route path="/add-service-step-2/:carId/:carTitle" element={<ServiceStepTwo />} />
                  <Route path="/add-service-step-3/:carId/:carTitle/:operKindId/:operKindTitle/:serviceType/:mtbo/:unit" element={<ServiceStepThree />} />
                  <Route path="/oper-reg" element={<OperReg />} />
                  <Route path="/operate-edit" element={<OperEdit />} />
                  {/* <Route path="/all-operdon" element={<OperdonIntersectionObserverApiPaging />} /> */}
                  {/* <Route path="/all-operdon" element={<OperdonPaging />} /> */}
                  <Route path="/all-operdon" element={<OperdonInfinitPaging />} />
                  <Route path="/edit-operdon/:id" element={<EditOperdon />} />
                  <Route path="/change-pass" element={<ChangePassword />} />
                  <Route path="/subscription" element={<Subscription />} />
                  <Route path="/account" element={<EditProfileForm />} />
                  <Route path="/contact" element={<ContactUs />} />

                  <Route path="*" element={<NotFoundPage />} />
                </Route>
              </Routes>
            {/* </MainLayout> */}
          </BrowserRouter>
        </HelmetProvider>

        <UpdateNotification />
    </>
  );
}

export default App;
